import { site } from '@shared/site.config';
import { useTitle } from '@/lib/useTitle';
import ServiceSheet from '@/components/ServiceSheet';

const service = site.services[0];

const ASSET_TYPES = [
  'Office',
  'Retail',
  'Industrial',
  'Multi-residential (5+ units)',
  'Development land',
];

export default function BuyingSelling() {
  useTitle(service.name, service.summary);

  return (
    <ServiceSheet
      sheetNo="A-01"
      service={service}
      glyph="office"
      tags={ASSET_TYPES}
      tagsLabel="Asset types"
      interest="buying-selling"
      ctaLabel="Start a conversation"
      closingLine="Buying or selling — across all four cities, start to close."
    />
  );
}
